import { Component, HostListener, Input, Optional, ViewEncapsulation } from '@angular/core';
import { DropDownComponent } from '../drop.down.component';
import { DropDownItemGroupComponent } from '../item.group/drop.down.item.group.component';

@Component({
    selector: 'ig-drop-down-item',
    templateUrl: './drop.down.item.component.html',
    styleUrls: ['./drop.down.item.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DropDownItemComponent {

    constructor(private container: DropDownComponent,
                @Optional() private groupContainer: DropDownItemGroupComponent) {
    }

    @HostListener('click', ['$event'])
    public onClick(event) {
        if (event && ((event.target as any).className == 'md2-datepicker-input'
            || (event.target as any).className == 'md2-calendar-body-cell-content')) {
            return;
        }
        event.stopPropagation();
        this.container.close();

        if (!!this.groupContainer) {
            this.groupContainer.isHovering = false;
        }
    }
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/drop.down/item/drop.down.item.component.ts